import { InformationTilesBlock } from 'cms-types'
import { InformationTiles as InformationTilesUI, type LoadableComponentProps } from 'ui'

function InformationTiles({ data, loading }: LoadableComponentProps<InformationTilesBlock>) {
  if (loading) return <InformationTilesUI loading />
  return <InformationTilesUI data={data} />
}

export default InformationTiles
InformationTiles.loadable = true
